/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync>): BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync(), model);
        BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync>): BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync.newInstance(<BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
